import { gql } from '@apollo/client';

export const LOCALIZATION_COUNTRY_QUERY = gql`
  query LocalizationCountryQuery {
    localizationCountry @client
  }
`;
